<button
  class="action-btn {{ type }}-btn"
  [class.full-width]="fullWidth"
  [class.loading-effect]="isLoading"
  [class.abbreviated]="abbreviation"
  [disabled]="disabled"
>
  @if (icon && iconPosition === 'start') {
    <span class="icon">
      <ui-svg-icon [svgIcon]="icon" [size]="iconSize" />
    </span>
  }
  @if (label) {
    <span style="line-height: 140%" class="label">{{ label }}</span>
  }
  @if (abbreviation) {
    <span style="line-height: 140%" class="label-abbreviation">
      {{ abbreviation }}
    </span>
  }
  @if (icon && iconPosition === 'end') {
    <span class="icon">
      <ui-svg-icon [svgIcon]="icon" [size]="iconSize" />
    </span>
  }
</button>
